import React, { useEffect, useState } from "react";
import {
  Modal,
  TextField,
  Banner,
  FormLayout,
} from "@shopify/polaris";

export const RequestReportModal = ({ open, setOpen }) => {
  const [text, setText] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setText("");
    setError("");
    setSuccess("");
    setLoading(false);
  }, [open]);

  const handleSubmit = async () => {
    setError("");
    setSuccess("");
    setLoading(true);

    if (!text.trim()) {
      setError("You must enter some information");
      setLoading(false);
      return;
    }

    return fetch("/api/shop/request-report", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text }),
    })
      .then((res) => res.json())
      .then(({ success }) => {
        if (!success) {
          throw new Error();
        }

        setSuccess("Thank you for your submission. We will review it within the next 24 hours.");
      })
      .catch(() => {
        setError("An error occurred while submitting your request. Please try again or contact support directly.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  let errorToRender;
  if (error) {
    errorToRender = (
      <Banner
        title="Error"
        tone="critical"
        action={{
          content: "Contact support",
          onAction: () => window.$crisp.push(["do", "chat:open"]),
        }}
      >
        {error}
      </Banner>
    )
  }

  let successToRender;
  if (success) {
    successToRender = (
      <Banner
        title="Success"
        tone="success"
      >
        {success}
      </Banner>
    )
  }

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      title="Share your feedback"
      primaryAction={{
        content: "Submit",
        onAction: handleSubmit,
        loading: loading,
      }}
      secondaryActions={[
        {
          content: "Cancel",
          onAction: () => setOpen(false),
        },
      ]}
    >
      <Modal.Section>
        <FormLayout>
          {errorToRender}
          {successToRender}

          <TextField
            label="How can we improve Origin?"
            value={text}
            onChange={setText}
            multiline={3}
            autoComplete="off"
          />
        </FormLayout>
      </Modal.Section>
    </Modal>
  );
};
